import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="payment-link"
export default class extends Controller {
  static targets = [
    "generateButton",
    "linkContainer",
    "urlInput",
    "copyButton",
    "errorMessage",
    "successMessage",
  ];

  async generate(event) {
    event.preventDefault();

    const url = this.generateButtonTarget.dataset.url;
    const button = this.generateButtonTarget;

    // Show loading state
    const originalText = button.textContent;
    button.textContent = "Generating...";
    button.disabled = true;

    // Hide previous messages
    this.hideMessages();

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
      });

      const data = await response.json();

      if (response.ok) {
        // Show the payment link
        this.urlInputTarget.value = data.url;
        this.linkContainerTarget.classList.remove("hidden");
        this.generateButtonTarget.classList.add("hidden");
      } else {
        this.showError(data.error || "Failed to generate payment link");
      }
    } catch (error) {
      console.error("Error generating payment link:", error);
      this.showError("An unexpected error occurred. Please try again.");
    } finally {
      // Reset button state
      button.textContent = originalText;
      button.disabled = false;
    }
  }

  async copy(event) {
    event.preventDefault();

    const url = this.urlInputTarget.value;

    try {
      await navigator.clipboard.writeText(url);
      this.showSuccess();

      // Hide success message after 3 seconds
      setTimeout(() => {
        this.successMessageTarget.classList.add("hidden");
      }, 3000);
    } catch (error) {
      console.error("Failed to copy:", error);
      this.showError("Failed to copy link. Please copy manually.");
    }
  }

  showError(message) {
    this.hideMessages();
    this.errorMessageTarget.textContent = message;
    this.errorMessageTarget.classList.remove("hidden");
  }

  showSuccess() {
    this.hideMessages();
    this.successMessageTarget.classList.remove("hidden");
  }

  hideMessages() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.add("hidden");
    }
    if (this.hasSuccessMessageTarget) {
      this.successMessageTarget.classList.add("hidden");
    }
  }
}
